var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"max-height":"100vh"},attrs:{"id":"inspire"}},[_c('v-main',[_c('div',{staticClass:"app-content-container boxed-container pa-6"},[_c('router-view'),_c('snackbar-cmp')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }